document.documentElement.classList.remove('no-js');

class ReleaseWall {
  constructor(section) {
    this.section = section;
    this.dialog = section.querySelector('[data-release-dialog]');
    this.content = section.querySelector('[data-release-dialog-content]');

    if (!this.dialog || !this.content) return;

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-release-open]');
      if (!trigger) return;

      const template = section.querySelector(`#${CSS.escape(trigger.dataset.releaseTemplate)}`);
      if (!template) return;

      this.content.replaceChildren(template.content.cloneNode(true));
      this.dialog.showModal();
      document.body.classList.add('dialog-open');
    });

    this.dialog.addEventListener('close', () => {
      document.body.classList.remove('dialog-open');
      this.content.replaceChildren();
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

const initReleaseWalls = (root = document) => {
  root.querySelectorAll('[data-release-wall]').forEach((section) => {
    if (!section.dataset.releaseWallReady) {
      section.dataset.releaseWallReady = 'true';
      new ReleaseWall(section);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initReleaseWalls());
document.addEventListener('shopify:section:load', (event) => initReleaseWalls(event.target));

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (!menuButton) return;

  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;

  const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!isOpen));
  menu.hidden = isOpen;
});
